// ==============================
// 파일명 : src/constants/users/fields.js
// 역할 : 사용자 문서에서 반복되는 필드 이름(예: 인증 UID)을
//         상수로 정의하여 Firestore 접근 시 오타를 방지
// 수정일 : 2025-10-13
// ==============================

export const USER_FIELD_AUTH_UID = "authUid"; // [수정] Firebase Authentication UID 필드 이름